module.exports = require("lodash.find");